var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestmentActive28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0834 18.6667V9.33333C11.0834 8.05 12.1217 7 13.4167 7H23.9167V5.83333C23.9167 4.55 22.8667 3.5 21.5834 3.5H5.25008C3.95508 3.5 2.91675 4.55 2.91675 5.83333V22.1667C2.91675 23.45 3.95508 24.5 5.25008 24.5H21.5834C22.8667 24.5 23.9167 23.45 23.9167 22.1667V21H13.4167C12.1217 21 11.0834 19.95 11.0834 18.6667ZM14.5834 9.33333C13.9417 9.33333 13.4167 9.85833 13.4167 10.5V17.5C13.4167 18.1417 13.9417 18.6667 14.5834 18.6667H25.0834V9.33333H14.5834ZM18.0834 15.75C17.1151 15.75 16.3334 14.9683 16.3334 14C16.3334 13.0317 17.1151 12.25 18.0834 12.25C19.0517 12.25 19.8334 13.0317 19.8334 14C19.8334 14.9683 19.0517 15.75 18.0834 15.75Z",
    fill: "#1C2227"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentActive28);
export default __webpack_public_path__ + "static/media/investment_active_28.74b82a9be90cc9f366eea768a5c02b8b.svg";
export { ForwardRef as ReactComponent };